import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = { advanceUrlTemplate: String, csrfToken: String }

  connect() {
    this.sortables = []

    this.element.querySelectorAll("[data-kanban-column]").forEach(column => {
      const sortable = Sortable.create(column, {
        group: "kanban",
        animation: 150,
        ghostClass: "kanban-ghost",
        dragClass: "kanban-drag",
        onEnd: (evt) => this.onDrop(evt)
      })
      this.sortables.push(sortable)
    })
  }

  disconnect() {
    this.sortables.forEach(s => s.destroy())
    this.sortables = []
  }

  onDrop(evt) {
    const card = evt.item
    const toColumn = evt.to
    const newStage = toColumn.dataset.stage
    const entryId = card.dataset.entryId
    const originalStage = card.dataset.currentStage

    if (newStage === originalStage) return

    const url = this.advanceUrlTemplateValue
      .replace("__ENTRY_ID__", entryId)

    card.classList.add("kanban-loading")

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": this.csrfTokenValue,
        "Accept": "text/vnd.turbo-stream.html, text/html"
      },
      body: new URLSearchParams({ stage: newStage })
    })
    .then(res => {
      if (res.ok) {
        card.dataset.currentStage = newStage
        this.updateColumnCounts()
      } else {
        // Revert: move card back to original column
        const originalCol = this.element.querySelector(`[data-stage="${originalStage}"] [data-kanban-column]`) ||
                            this.element.querySelector(`[data-stage="${originalStage}"]`)
        if (originalCol) originalCol.appendChild(card)
        this.updateColumnCounts()
      }
    })
    .catch(() => {
      const originalCol = this.element.querySelector(`[data-stage="${originalStage}"]`)
      if (originalCol) originalCol.appendChild(card)
    })
    .finally(() => {
      card.classList.remove("kanban-loading")
    })
  }

  updateColumnCounts() {
    this.element.querySelectorAll("[data-kanban-stage-wrapper]").forEach(wrapper => {
      const stage = wrapper.dataset.kanbanStageWrapper
      const count = wrapper.querySelectorAll("[data-entry-id]").length
      const badge = wrapper.querySelector("[data-count-badge]")
      if (badge) badge.textContent = count
    })
  }
}
